<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/number/change/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_equipment_list'"-->
            <!--							:ids.sync="yt.conditions.equipmentIds">-->
            <!--						</yi_cross_select>-->
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIdList"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds">-->
            <!--						</yi_cross_select>-->
          </el-form-item>

          <el-form-item :label="$t('caozuoshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('caozuoren')">
            <el-input v-model="yt.conditions.createUserName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: begin(), createTimeEnd: end() })">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <!--<el-button size="mini"-->
        <!--@click="yt.exportExcel()"-->
        <!--type="primary">-->
        <!--{{ $t('daochu') }}-->
        <!--</el-button>-->
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="yt.exportExcel($t('web_production_management_change_cavity_record'))"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_production_management_delete_record_list",

  data() {
    return {
      list: [],
      columns: [
        {
          label: "shengchangongdanhao",
          prop: "no",
        },
        {
          label: "ERPgongdanhao",
          prop: "erpNo",
        },
        {
          label: "shebeimingcheng",
          prop: "equipmentName",
        },
        {
          label: "mujubianhao",
          prop: "mould.no",
        },
        {
          label: "mujumingcheng",
          prop: "mouldName",
        },
        {
          label: "chanpinbianma",
          prop: "materialCode",
        },
        {
          label: "chanpinmingcheng",
          prop: "materialName",
        },
        {
          label: "xiugaiqianmoqiangshu",
          prop: "mouldNumBefore",
        },
        {
          label: "xiugaihoumoqiangshu",
          prop: "mouldNumAfter",
        },
        {
          label: "caozuoren",
          prop: "createUserName",
        },
        {
          label: "caozuoshijian",
          prop: "createTime",
          type: "time",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // this.yt.get(1);
      this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, "createTimeStart", this.begin());
      this.$set(this.yt.conditions, "createTimeEnd", this.end());
      this.yt.list = [];
    }, 300);
  },
  methods: {
    beforeGet(params) {
      params["createTimeStart"] = this.begin();
      params["createTimeEnd"] = this.end();
      return params;
    },

    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "01" + " 00:00:00").getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()).getTime();
      return end;
    },
    // 重置
    // clear() {
    // 	this.yt.conditions = {
    // 		createTimeStart: this.begin(),
    // 		createTimeEnd: this.end()
    //
    // 	}
    // 	this.yt.list = []
    // },
  },
};
</script>
